// extracted by mini-css-extract-plugin
module.exports = {"root":"loginForm_root__3Tu6c","logo":"loginForm_logo__1Tw29","subtitle":"loginForm_subtitle__3ufjm","forgotPassword":"loginForm_forgotPassword__2UJZw"};